
import Vue from "vue"

export default Vue.extend({
  layoutSettings: {
    noBanner: true,
    titleToken: "pages.auth.registration.title",
  },

  data: () => ({
    sended: false,
  }),

  methods: {
    send () {
      this.sended = true
      window.scrollTo(0, 0)
    },
  },
})
